const ACCESS_TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";
const REFRESH_TOKEN_EXPIRY = "refreshTokenExpiry";
const USER_ID = "userId";
const FULL_NAME = "fullName";

const tokenService = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN),

  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN),

  getRefreshTokenExpiry: () => localStorage.getItem(REFRESH_TOKEN_EXPIRY),

  getUserId: () => localStorage.getItem(USER_ID),

  getFullName: () => localStorage.getItem(FULL_NAME),

  setTokens: ({
    accessToken,
    refreshToken,
    refreshTokenExpiry,
    userId,
    fullName,
  }) => {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
    localStorage.setItem(REFRESH_TOKEN_EXPIRY, refreshTokenExpiry);
    localStorage.setItem(USER_ID, userId);
    localStorage.setItem(FULL_NAME, fullName);
  },

  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN_EXPIRY);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(FULL_NAME);
  },
};

export default tokenService;